import { useEffect, useRef } from "react";
import { Mixpanel } from "lib/mixpanel/mixpanel";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";

import { DatoImage } from "components/image/datoImage";
import Heading from "content-ui/briefings/components/briefingsReports/elements/heading";
import CardContainer from "content-ui/briefings/components/briefingsReports/elements/cardContainer";
import { LazyIframe } from "components/lazyIframe/lazyIframe";

import { MIXPANEL_TOKEN } from "lib/constants";
import { useUserData } from "lib/store/user";

const MapCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  const mixpanelRef = useRef<Mixpanel | null>(null);
  const { userId } = useUserData();

  useEffect(() => {
    mixpanelRef.current = new Mixpanel(MIXPANEL_TOKEN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const track = () => {
    if (userId && mixpanelRef.current) {
      mixpanelRef.current.track("Briefing Market Map", {
        Interaction: "Toggled zoom",
        distinct_id: userId,
        "Briefing title": briefing.name,
      });
    }
  };

  const flourishHeight = briefing.marketMapFlourishHeight
    ? `${briefing.marketMapFlourishHeight}px`
    : "700px";

  return (
    <CardContainer id={`content__${id}`}>
      <Heading text={briefing.marketMapHeading} id={id} />
      {briefing.marketMapFlourishId ? (
        <div className="mb-6 w-100 md:mb-8">
          <LazyIframe
            title="Interactive or visual content"
            src={`https://flo.uri.sh/visualisation/${briefing.marketMapFlourishId}/embed`}
            className="flourish-embed-iframe"
            frameBorder="0"
            scrolling="no"
            style={{ width: "100%", height: flourishHeight }}
          ></LazyIframe>
        </div>
      ) : (
        <>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            className="mt-2 flex justify-center"
            onClick={() => track()}
            onKeyDown={(e) => {
              if (e.code === "Space" || e.code === "Enter") track();
            }}
          >
            {briefing?.marketMap?.url && (
              <Zoom
                overlayBgColorEnd="rgba(255, 255, 255, 0.96)"
                zoomMargin={16}
              >
                <DatoImage
                  containerClassName="inline-block"
                  src={briefing?.marketMap?.url}
                  width={briefing?.marketMap?.width}
                  height={briefing?.marketMap?.height}
                  blurDataURL={briefing?.marketMap?.blurUpThumb}
                  placeholder="blur"
                  alt={briefing.marketMapHeading}
                />
              </Zoom>
            )}
          </div>
        </>
      )}
    </CardContainer>
  );
};

export default MapCard;
